import { Skeleton, styled, Typography } from "@mui/material";

const MainContainer = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	justifyContent: "flex-start",
	alignItems: "flex-start",
	width: "100%",
	height: "100%",
	gap: "0.5rem",
	padding: "1rem 1rem 1rem 1rem",
	background: theme.palette.background.paper,
	boxShadow: "none",
	borderRadius: "16px",
}));

const Heading = styled(Typography)(({ theme }) => ({
	margin: "0rem 0rem 0.5rem 0rem",
	width: "100%",
	fontWeight: "500",
	fontSize: "1rem",
	[theme.breakpoints.up("sm")]: {
		fontSize: "1rem",
	},
	[theme.breakpoints.up("md1190")]: {
		fontSize: "1.125rem",
	},
}));

const PDFCardDesktopSkeleton = () => {
	return (
		<MainContainer>
			<Heading>
				<Skeleton
					animation="wave"
					variant="rectangular"
					width="10rem"
					height="1rem"
					style={{ borderRadius: "0.5rem" }}
				/>
			</Heading>

			<Skeleton
				animation="wave"
				variant="rectangular"
				width="100%"
				height="3rem"
				style={{ borderRadius: "0.5rem" }}
			/>
		</MainContainer>
	);
};

export default PDFCardDesktopSkeleton;
